import anime from 'animejs';

export function fadeInit(el, y = 20) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime.set(elToTween, { opacity: 0, translateY: y });

  return tween;
}

export function fadeAnim(el, delay = 0, opacity = 1) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime({
    targets: elToTween,
    opacity,
    translateY: 0,
    duration: 1500,
    delay,
  });

  return tween;
}

export function fadeAnimReverse(el, delay = 0, y = -80) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime({
    targets: elToTween,
    opacity: [1, 0],
    translateY: y,
    duration: 1000,
    delay,
  });

  return tween;
}

export function fadeVideoInit(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime.set(elToTween, { opacity: 0, translateY: 100 });

  return tween;
}

export function fadeVideoAnim(el, delay = 500) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime({
    targets: elToTween,
    opacity: 1,
    translateY: 0,
    duration: 2000,
    delay,
  });

  return tween;
}
